import { FiltersProvider } from 'legacyfrontend/contexts/FiltersContext';
import SearchSelector from 'legacyfrontend/components/home/components/SearchSelector';
import PackagesListView from './PackagesListView';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import { useState, useEffect, useMemo } from 'react';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import { useLocation } from 'react-router-dom';

const PackageListPage = () => {
  const { onSearchCount } = useGlobal();
  const { search } = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  const hasValidSearchParams = useMemo(() => {
    if (!search) return false;

    const searchParams = new URLSearchParams(search);
    const hasOrigin = searchParams.get('originId') && searchParams.get('originName');
    const hasDestination = searchParams.get('destinationId') && searchParams.get('destinationName');
    const hasDates = searchParams.get('monthYear');

    return hasOrigin && hasDestination && hasDates;
  }, [search]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isClient ? window.innerWidth <= 768 : false);
    };
    handleResize();
    isClient && window.addEventListener('resize', handleResize);
    return () => isClient && window.removeEventListener('resize', handleResize);
  }, []);

  const shouldShowFilters = onSearchCount > 0 || hasValidSearchParams;

  return (
    <FiltersProvider>
      <SearchSelector isOnTargetPath />
      {shouldShowFilters && <PackagesListView />}
    </FiltersProvider>
  );
};

export default PackageListPage;
